/* imods-symptom (symptoms-1, 2026-10-02): step view for the symptom pages. Presentation only: every situation and every
   model's causes are in the HTML (sections/imods-symptom.liquid). Sets [data-c] (situation anchor, "" = the head situation,
   "*" = every situation) and [data-m] (model key) on .sym; the model is shared with the rest of the site through imods.yours
   (sessionStorage, owner ruling D-11 A). A #anchor in the URL opens that situation. */
(function () {
  var root = document.querySelector('[data-sym-root]');
  if (!root) return;
  var I = window.imods || {};
  var KEYS = ['3G', '4G', 'Photo', '5G', '6G', '7G', 'Mini1', 'Mini2'];
  var secs = Array.prototype.slice.call(root.querySelectorAll('[data-sym-sec]'));
  var ids = secs.map(function (s) { return s.id; });
  var links = Array.prototype.slice.call(root.querySelectorAll('[data-sym-choice]'));
  var radios = Array.prototype.slice.call(root.querySelectorAll('[data-sym-model]'));
  var showing = root.querySelector('[data-sym-showing]');
  var showingText = root.querySelector('[data-sym-showing-text]');
  var state = { c: '', m: '', f: '' };
  // a family picked in the iPod Repair menu (?ipod=<family>) wins over a remembered model from another family (Codex review 2026-10-02)
  var FAMS = { classic: ['6G', '7G'], video: ['5G'], g4photo: ['4G', 'Photo'], mini: ['Mini1', 'Mini2'], g3: ['3G'] };
  var famParam = null;
  try { famParam = new URLSearchParams(location.search).get('ipod'); } catch (err) {}

  function hashAnchor() {
    var h = decodeURIComponent((location.hash || '').replace(/^#/, ''));
    return ids.indexOf(h) >= 0 ? h : '';
  }
  function labelOf(anchor) {
    var a = links.filter(function (l) { return l.getAttribute('data-sym-choice') === anchor; })[0];
    var l = a && a.querySelector('.sym-choice__l');
    return l ? l.textContent.trim() : '';
  }
  function modelLabel(k) {
    var r = radios.filter(function (x) { return x.value === k; })[0];
    return r ? r.getAttribute('data-label') : '';
  }
  function rerank() {
    root.querySelectorAll('.sym-fam').forEach(function (fam) {
      var n = 0;
      fam.querySelectorAll('.sym-cause').forEach(function (c) {
        if (c.offsetParent === null) return;
        n += 1;
        var r = c.querySelector('.sym-cause__rank');
        if (r) r.textContent = n === 1 ? 'Most likely' : n === 2 ? 'Next most likely' : 'Also possible';
      });
    });
  }
  function apply() {
    root.setAttribute('data-c', state.c);
    root.setAttribute('data-m', state.m);
    root.setAttribute('data-f', state.f);
    secs.forEach(function (s) { s.classList.toggle('is-on', s.id === state.c); });
    links.forEach(function (l) {
      if (l.getAttribute('data-sym-choice') === state.c) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
    });
    radios.forEach(function (r) { r.checked = r.value === state.m; });
    var parts = [];
    if (state.c && state.c !== '*') parts.push(labelOf(state.c));
    if (state.m) parts.push(modelLabel(state.m));
    if (showing) {
      showing.hidden = !(parts.length || state.c === '*');
      if (showingText) showingText.textContent = state.c === '*' ? 'Showing every situation.' : 'Showing ' + parts.join(' on the ') + '.';
    }
    rerank();
  }
  function scrollTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  function target() {
    return state.c && state.c !== '*' ? document.getElementById(state.c) : secs.filter(function (s) { return s.getAttribute('data-kind') === 'head'; })[0];
  }

  root.classList.add('sym--js');
  state.c = hashAnchor();
  var y = I.yours && I.yours.get ? I.yours.get() : null;
  if (y && KEYS.indexOf(y.key) >= 0) state.m = y.key;
  // owner 2026-10-02: the menu has one tab per model, so ?ipod= can also be a model key: open the page on exactly that model
  if (famParam && KEYS.indexOf(famParam) >= 0) state.m = famParam;
  else if (famParam && FAMS[famParam]) {
    if (FAMS[famParam].length === 1) state.m = FAMS[famParam][0];
    else if (FAMS[famParam].indexOf(state.m) < 0) { state.m = ''; state.f = famParam; }
  }
  apply();
  if (state.c) scrollTo(document.getElementById(state.c));

  links.forEach(function (l) {
    l.addEventListener('click', function (e) {
      e.preventDefault();
      state.c = l.getAttribute('data-sym-choice');
      try { history.replaceState(null, '', '#' + state.c); } catch (err) {}
      apply();
      if (!state.m) {
        var step = document.getElementById('which-ipod');
        scrollTo(step);
        var first = step && step.querySelector('input');
        if (first) first.focus({ preventScroll: true });
      } else {
        scrollTo(target());
      }
    });
  });
  radios.forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      state.m = r.value; state.f = '';
      if (I.yours && I.yours.set) I.yours.set({ key: r.value, label: r.getAttribute('data-label') });
      if (state.c === '*') state.c = '';
      apply();
      scrollTo(target());
    });
  });
  var all = root.querySelector('[data-sym-all]');
  if (all) all.addEventListener('click', function () { state.c = '*'; state.m = ''; state.f = ''; try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {} apply(); });
  window.addEventListener('hashchange', function () { var h = hashAnchor(); if (h) { state.c = h; apply(); scrollTo(document.getElementById(h)); } });
})();
